import {
    ADD_HERO_IMAGE_IN_THE_META_EDIT_POPUP,
    ADD_LOCATION_IN_META_POPUP,
    DELETE_HERO_IMAGE_FIELD_IN_THE_META_EDIT_POPUP,
    FETCHED_OVERVIEW_ACCOMMODATIONS,
    FETCHED_OVERVIEW_DATES,
    FETCHED_OVERVIEW_REQUIREMENTS,
    OPEN_EDIT_META_SECTION_POPUP_POPUP,
    REMOVE_LOCATION_IN_META_POPUP,
    SET_LOCATIONS_IN_META_POPUP,
    UPDATE_HERO_CROPPED_IMAGE_IN_THE_EDIT_POPUP,
    UPDATE_HERO_IMAGE_META_IN_THE_EDIT_POPUP,
    UPDATE_HERO_THUMB_CROPPED_IMAGE_IN_THE_EDIT_POPUP,
    UPDATE_SECTION_BREADCRUMB_TITLE_IN_THE_META_POPUP,
    UPDATE_SECTION_MENU_TITLE_IN_THE_META_POPUP,
    UPDATE_SECTION_META_DESCRIPTION_IN_THE_META_POPUP,
    UPDATE_SECTION_META_TITLE_IN_THE_META_POPUP,
    UPDATE_SECTION_OLD_URL_IN_THE_META_POPUP,
    UPDATE_HERO_VIDEO_URL_IN_THE_META_POPUP,
    UPDATE_SECTION_SUBHEADING_IN_THE_META_POPUP,
    UPDATE_SECTION_TITLE_IN_THE_META_POPUP,
    UPDATE_SECTION_REVIEW_ABBREVIATED_NAME_IN_THE_META_POPUP,
    UPDATE_SECTION_REVIEW_AGE_GROUP_IN_THE_META_POPUP,
    UPDATE_SECTION_REVIEW_FULL_NAME_IN_THE_META_POPUP,
    UPDATE_SECTION_REVIEW_LANGUAGE_IN_THE_META_POPUP,
    UPDATE_SECTION_REVIEW_QUOTE_IN_THE_META_POPUP,
    UPDATE_SECTION_TEAM_IN_THE_META_POPUP,
    UPDATE_SECTION_BLOG_AUTHOR_IN_THE_META_POPUP,
    UPDATE_SECTION_BLOG_DATE_IN_THE_META_POPUP,
    UPDATE_SNIPPET_TEXT_IN_THE_META_EDIT_POPUP,
    UPDATE_SNIPPET_SORT_ORDER_FIELD_IN_THE_META_EDIT_POPUP,
    UPDATE_SNIPPET_ATTRIBUTE_FIELD_IN_THE_META_EDIT_POPUP,
    UPDATE_IS_TRAVEL_PRODUCT_FIELD_IN_THE_META_EDIT_POPUP,
    UPDATE_OVERVIEW_DATES_IN_THE_META_EDIT_POPUP,
    UPDATE_OVERVIEW_REQUIREMENTS_IN_THE_META_EDIT_POPUP,
    UPDATE_OVERVIEW_ADDITIONAL_REQUIREMENTS_IN_THE_META_EDIT_POPUP,
    UPDATE_OVERVIEW_ACCOMMODATION_IN_THE_META_EDIT_POPUP,
    FETCHED_PRODUCTS,
    UPDATE_SECTION_REVIEW_PRODUCTS_IN_THE_META_POPUP,
    UPDATE_SECTION_LANDING_PRODUCTS_IN_THE_META_POPUP,
    DELETE_REVIEW_IMAGE_FIELD_IN_THE_META_EDIT_POPUP,
    ADD_REVIEW_IMAGE_IN_THE_META_EDIT_POPUP,
    UPDATE_REVIEW_THUMB_CROPPED_IMAGE_IN_THE_EDIT_POPUP,
    UPDATE_REVIEW_CROPPED_IMAGE_IN_THE_EDIT_POPUP,
    UPDATE_REVIEW_IMAGE_META_IN_THE_EDIT_POPUP,
    FETCHED_SNIPPET_ATTRIBUTE_OPTIONS,
} from './types';

export function setSelectedLocations(locations) {
    return {
        type: SET_LOCATIONS_IN_META_POPUP,
        payload: {
            locations: locations,
        },
    };
}

export function addLocation(location) {
    return {
        type: ADD_LOCATION_IN_META_POPUP,
        payload: {
            location: location,
        },
    };
}

export function removeLocation(location) {
    return {
        type: REMOVE_LOCATION_IN_META_POPUP,
        payload: {
            location: location,
        },
    };
}

export function updatePageMetaDescriptionField(newValue) {
    return {
        type: UPDATE_SECTION_META_DESCRIPTION_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageMetaReviewFullName(newValue) {
    return {
        type: UPDATE_SECTION_REVIEW_FULL_NAME_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageMetaBlogAuthor(newValue) {
    return {
        type: UPDATE_SECTION_BLOG_AUTHOR_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageMetaBlogDate(newValue) {
    return {
        type: UPDATE_SECTION_BLOG_DATE_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageMetaReviewProducts(newValue) {
    return {
        type: UPDATE_SECTION_REVIEW_PRODUCTS_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageMetaLandingProducts(newValue) {
    return {
        type: UPDATE_SECTION_LANDING_PRODUCTS_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageMetaReviewAbbrName(newValue) {
    return {
        type: UPDATE_SECTION_REVIEW_ABBREVIATED_NAME_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageMetaReviewQuote(newValue) {
    return {
        type: UPDATE_SECTION_REVIEW_QUOTE_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageMetaReviewLanguage(newValue) {
    return {
        type: UPDATE_SECTION_REVIEW_LANGUAGE_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageMetaReviewAgeGroup(newValue) {
    return {
        type: UPDATE_SECTION_REVIEW_AGE_GROUP_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageMetaTeam(newValue) {
    return {
        type: UPDATE_SECTION_TEAM_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function fetchedProducts(products) {
    return {
        type: FETCHED_PRODUCTS,
        payload: {
            products: products,
        },
    };
}

export function updatePageMetaTitleField(newValue) {
    return {
        type: UPDATE_SECTION_META_TITLE_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageTitleField(newValue) {
    return {
        type: UPDATE_SECTION_TITLE_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageSubheadingField(newValue) {
    return {
        type: UPDATE_SECTION_SUBHEADING_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageOldUrlField(newValue) {
    return {
        type: UPDATE_SECTION_OLD_URL_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updateHeroVideoUrlField(newValue) {
    return {
        type: UPDATE_HERO_VIDEO_URL_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageBreadcrumbTitleField(newValue) {
    return {
        type: UPDATE_SECTION_BREADCRUMB_TITLE_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updatePageMenuTitleField(newValue) {
    return {
        type: UPDATE_SECTION_MENU_TITLE_IN_THE_META_POPUP,
        payload: newValue,
    };
}

export function updateSnippetField(newValue) {
    return {
        type: UPDATE_SNIPPET_TEXT_IN_THE_META_EDIT_POPUP,
        payload: newValue,
    };
}

export function updateDatesField(selectedDate) {
    return {
        type: UPDATE_OVERVIEW_DATES_IN_THE_META_EDIT_POPUP,
        payload: selectedDate,
    };
}

export function updateRequirementsField(selectedRequirement) {
    return {
        type: UPDATE_OVERVIEW_REQUIREMENTS_IN_THE_META_EDIT_POPUP,
        payload: selectedRequirement,
    };
}

export function updateAdditionalRequirementsField(additionalRequirements) {
    return {
        type: UPDATE_OVERVIEW_ADDITIONAL_REQUIREMENTS_IN_THE_META_EDIT_POPUP,
        payload: additionalRequirements,
    };
}

export function updateAccommodationsField(selectedAccommodation) {
    return {
        type: UPDATE_OVERVIEW_ACCOMMODATION_IN_THE_META_EDIT_POPUP,
        payload: selectedAccommodation,
    };
}

export function updateSnippetSortOrderField(selectedSnippetSortOrder) {
    return {
        type: UPDATE_SNIPPET_SORT_ORDER_FIELD_IN_THE_META_EDIT_POPUP,
        payload: selectedSnippetSortOrder,
    };
}

export function updateSnippetAttributeField(selectedSnippetAttribute) {
    return {
        type: UPDATE_SNIPPET_ATTRIBUTE_FIELD_IN_THE_META_EDIT_POPUP,
        payload: selectedSnippetAttribute,
    };
}

export function updateIsTravelProduct(value) {
    return {
        type: UPDATE_IS_TRAVEL_PRODUCT_FIELD_IN_THE_META_EDIT_POPUP,
        payload: value,
    };
}

export function updateHeroImageField(images) {
    return {
        type: ADD_HERO_IMAGE_IN_THE_META_EDIT_POPUP,
        payload: {
            image: images[0],
        },
    };
}

export function updateReviewImageField(images) {
    return {
        type: ADD_REVIEW_IMAGE_IN_THE_META_EDIT_POPUP,
        payload: {
            image: images[0],
        },
    };
}

export function deleteHeroImageField() {
    return {
        type: DELETE_HERO_IMAGE_FIELD_IN_THE_META_EDIT_POPUP,
    };
}

export function deleteReviewImageField() {
    return {
        type: DELETE_REVIEW_IMAGE_FIELD_IN_THE_META_EDIT_POPUP,
    };
}

export function updateHeroImageMeta(imageMeta) {
    return {
        type: UPDATE_HERO_IMAGE_META_IN_THE_EDIT_POPUP,
        payload: {
            imageMeta: imageMeta,
        },
    };
}

export function updateReviewImageMeta(imageMeta) {
    return {
        type: UPDATE_REVIEW_IMAGE_META_IN_THE_EDIT_POPUP,
        payload: {
            imageMeta: imageMeta,
        },
    };
}

export function updateHeroCroppedImage(image, imageUrlBlob, imageBlobObject) {
    return {
        type: UPDATE_HERO_CROPPED_IMAGE_IN_THE_EDIT_POPUP,
        payload: {
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
        },
    };
}

export function updateReviewCroppedImage(image, imageUrlBlob, imageBlobObject) {
    return {
        type: UPDATE_REVIEW_CROPPED_IMAGE_IN_THE_EDIT_POPUP,
        payload: {
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
        },
    };
}

export function updateHeroThumbCroppedImage(
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_HERO_THUMB_CROPPED_IMAGE_IN_THE_EDIT_POPUP,
        payload: {
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
        },
    };
}

export function updateReviewThumbCroppedImage(
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_REVIEW_THUMB_CROPPED_IMAGE_IN_THE_EDIT_POPUP,
        payload: {
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
        },
    };
}

export function openMetaPageSectionPopup(data) {
    return {
        type: OPEN_EDIT_META_SECTION_POPUP_POPUP,
        payload: {
            data,
        },
    };
}

export function fetchedOverviewDates(dates) {
    return {
        type: FETCHED_OVERVIEW_DATES,
        payload: {
            dates,
        },
    };
}

export function fetchedOverviewRequirements(requirements) {
    return {
        type: FETCHED_OVERVIEW_REQUIREMENTS,
        payload: {
            requirements,
        },
    };
}

export function fetchedOverviewAccommodations(accommodations) {
    return {
        type: FETCHED_OVERVIEW_ACCOMMODATIONS,
        payload: {
            accommodations,
        },
    };
}

export function fetchedSnippetAttributeOptions(options) {
    return {
        type: FETCHED_SNIPPET_ATTRIBUTE_OPTIONS,
        payload: {
            options,
        },
    };
}



// WEBPACK FOOTER //
// ./src/containers/builder/meta/actions.js